import logger from 'utils/logger.util';

const L = logger('lsSet');

const lsSet = (key, val, options) => {
  try {
    if (!options?.quiet) L.debug(key, ':', val);
    localStorage.setItem(key, val);
    return val;
  } catch (e) {
    L.warn('lsSet()', e);
    return null;
  }
};

export default lsSet;
